import { Component, inject } from "@angular/core";
import { RouterModule, RouterOutlet, Router, NavigationEnd } from "@angular/router";
import { CommonModule } from "@angular/common";
import { AuthService } from "../services/auth.service";
import { filter } from 'rxjs/operators';

@Component({
    templateUrl: './standard.html',
imports: [CommonModule, RouterOutlet, RouterModule]
})
export class StandardPage {
    protected readonly auth = inject(AuthService);
    private readonly router = inject(Router);
    
    currentRoute = '';
    
    constructor() {
        // Track current route
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe((event: NavigationEnd) => {
            this.currentRoute = event.urlAfterRedirects;
        });
    }
    
    getPageTitle(): string {
        const route = this.currentRoute;
        
        if (route.includes('details')) {
            return 'Unser Hochzeitstag';
        } else if (route.includes('polter')) {
            return 'Polterabend';
        } else if (route.includes('form')) {
            return this.auth.hasFullAccess() ? 'Eure Antwort' : 'Anmeldung';
        } else if (route.includes('contact')) {
            return 'Kontakt & Beteiligung';
        }
        
        return '';
    }
    
    getPageSubtitle(): string {
        const route = this.currentRoute;
        
        if (route.includes('details')) {
            return '1. August 2026 • Ev. Marienkirche Blasheim';
        } else if (route.includes('polter')) {
            return '25. Juli 2026 • Privater Garten';
        } else if (route.includes('form')) {
            return 'Bitte meldet euch bis zum 1. Mai 2026 an';
        } else if (route.includes('contact')) {
            return 'Wir freuen uns auf eure Nachricht';
        }
        
        return '';
    }
    
    logout() {
        this.auth.logout();
        this.router.navigate(['/login']);
    }
}